import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

type Props = {
    header: React.ReactNode;
    // @default 1
    count?: number;
    children?: React.ReactNode;
};

const NotificationSettingsCategorySkeleton: React.FC<Props> = ({ header, count = 1, children }) => (
    <section className="notifications-settings__category">
        <div className="notifications-settings__category-header-wrapper">
            <h2 className="notifications-settings__category-header">{header}</h2>
        </div>
        <div className="notifications-settings__content-wrapper">
            {Array.from(Array(count)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className="notifications-settings__toggle-group" key={index}>
                    <DarkSkeleton width="100%" height={76} />
                </div>
            ))}
            {children}
        </div>
    </section>
);
export default NotificationSettingsCategorySkeleton;
